(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colony_compare_miners"] && !Shopify.designMode) return;
  try {
    
  class TopProfitableMiners extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.rowsContainer = this.querySelector('[data-profitable-miner-rows]');
      this.rows = Array.from(this.querySelectorAll('[data-profitable-miner]'));
      this.coinData = {
        BTC: { priceId: 'bitcoin', fallbackPrice: 64634, coinsPerHashDay: 4.996878992173439e-19 },
        LTC: { priceId: 'litecoin', fallbackPrice: 47.21, coinsPerHashDay: 1.3899838628744401e-12 },
        ETC: { priceId: 'ethereum-classic', fallbackPrice: 7.14, coinsPerHashDay: 9.96534008888848e-11 },
        KAS: { priceId: 'kaspa', fallbackPrice: 0.03148445, coinsPerHashDay: 5.55e-12 },
        ZEC: { priceId: 'zcash', fallbackPrice: 1215.58, coinsPerHashDay: 6.28755019673136e-8 },
        XMR: { priceId: 'monero', fallbackPrice: 428.4, coinsPerHashDay: 7.0047657471e-8 },
        XTM: { priceId: 'minotari-tari', fallbackPrice: 0.001537, coinsPerHashDay: 3.4413793103448277e-9 },
        ALEO: { priceId: 'aleo', fallbackPrice: 0.01289013, coinsPerHashDay: 1.0303616e-7 }
      };

      this.rankMiners();
      this.loadPrices();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    async loadPrices() {
      this.controller = new AbortController();

      try {
        const response = await fetch(this.dataset.endpoint, {
          headers: { Accept: 'application/json' },
          signal: this.controller.signal
        });
        if (!response.ok) return;

        const prices = await response.json();
        Object.values(this.coinData).forEach((coin) => {
          const livePrice = Number(prices[coin.priceId] && prices[coin.priceId].gbp);
          if (Number.isFinite(livePrice) && livePrice > 0) coin.livePrice = livePrice;
        });
        this.rankMiners();
      } catch (error) {
        if (error.name !== 'AbortError') this.rankMiners();
      }
    }

    rankMiners() {
      const ranked = this.rows.map((row) => {
        const coin = this.coinData[row.dataset.coin] || this.coinData.BTC;
        const hashrate = this.parseHashrate(row.dataset.hashrate);
        const power = Number(String(row.dataset.power || '0').replace(/,/g, ''));
        const grossDaily = hashrate * coin.coinsPerHashDay * (coin.livePrice || coin.fallbackPrice);
        const electricityDaily = power / 1000 * 24 * 0.05;
        return { row, netProfit: grossDaily - electricityDaily };
      }).sort((a, b) => b.netProfit - a.netProfit);

      ranked.forEach((item, index) => {
        item.row.hidden = index >= 5;
        this.rowsContainer.append(item.row);
      });
    }

    parseHashrate(value) {
      const normalized = String(value || '').replace(/,/g, '');
      const numbers = normalized.match(/\d+(?:\.\d+)?/g) || ['0'];
      const amount = Number(numbers[numbers.length - 1]);
      const unitMatch = normalized.match(/([KMGTPE]?)H\/?s/i);
      const unit = unitMatch ? unitMatch[1].toUpperCase() : '';
      const multipliers = { '': 1, K: 1e3, M: 1e6, G: 1e9, T: 1e12, P: 1e15, E: 1e18 };
      return amount * (multipliers[unit] || 1);
    }

  }

  if (!customElements.get('top-profitable-miners')) {
    customElements.define('top-profitable-miners', TopProfitableMiners);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crypto-price-ticker"] && !Shopify.designMode) return;
  try {
    
class CryptoPriceTicker extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.track = this.querySelector('.crypto-ticker__track');
    this.template = this.querySelector('template');
    this.changeLabel = this.dataset.changeLabel;
    this.refreshMs = Math.max(Number(this.dataset.refreshMs) || 60000, 30000);
    this.style.setProperty('--crypto-ticker-duration', (Number(this.dataset.speedSeconds) || 45) + 's');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reducedMotion) this.classList.add('crypto-ticker--static');
    this.loadPrices();
    this.timer = window.setInterval(() => this.loadPrices(), this.refreshMs);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    if (this.controller) this.controller.abort();
  }

  async loadPrices() {
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();

    try {
      const response = await fetch(this.dataset.endpoint, {
        headers: { Accept: 'application/json' },
        signal: this.controller.signal
      });

      if (!response.ok) throw new Error(String(response.status));
      const coins = await response.json();
      this.render(coins.slice(0, 10));
    } catch (error) {
      if (error.name === 'AbortError' || this.dataset.ready === 'true') return;
      const status = this.querySelector('.crypto-ticker__status');
      if (status) status.textContent = this.dataset.unavailableLabel;
    }
  }

  render(coins) {
    const group = document.createElement('div');
    group.className = 'crypto-ticker__group';

    coins.forEach((coin) => {
      const item = this.template.content.firstElementChild.cloneNode(true);
      const image = item.querySelector('.crypto-ticker__image');
      image.src = coin.image;
      item.querySelector('.crypto-ticker__symbol').textContent = String(coin.symbol).toUpperCase();
      item.querySelector('.crypto-ticker__price').textContent = this.formatPrice(coin.current_price);

      const change = Number(coin.price_change_percentage_24h) || 0;
      const changeElement = item.querySelector('.crypto-ticker__change');
      const changeClass = change > 0
        ? 'crypto-ticker__change--positive'
        : change < 0
          ? 'crypto-ticker__change--negative'
          : 'crypto-ticker__change--neutral';
      changeElement.classList.add(changeClass);
      changeElement.querySelector('.crypto-ticker__sr-only').textContent = this.changeLabel + ': ';
      changeElement.querySelector('.crypto-ticker__change-value').textContent =
        (change > 0 ? '+' : '') + change.toFixed(2) + '%';

      group.appendChild(item);
    });

    if (!group.children.length) return;

    const nodes = [group];
    if (!this.reducedMotion) {
      const duplicate = group.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      nodes.push(duplicate);
    }

    this.track.replaceChildren(...nodes);
    this.dataset.ready = 'true';
  }

  formatPrice(value) {
    const number = Number(value);
    const maximumFractionDigits = number >= 1 ? 2 : number >= 0.01 ? 4 : 8;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: number >= 1 ? 2 : 0,
      maximumFractionDigits
    }).format(number);
  }
}

if (!customElements.get('crypto-price-ticker')) {
  customElements.define('crypto-price-ticker', CryptoPriceTicker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mining-profitability-calculator"] && !Shopify.designMode) return;
  try {
    
class MinerProfitabilityCalculator extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.minerInput = this.querySelector('[data-miner]');
    this.variantInput = this.querySelector('[data-variant]');
    this.coinSelector = this.querySelector('[data-coin-selector]');
    this.coinInput = this.querySelector('[data-coin]');
    this.hashrateInput = this.querySelector('[data-hashrate]');
    this.priceInput = this.querySelector('[data-price]');
    this.dailyCoinsInput = this.querySelector('[data-daily-coins]');
    this.powerInput = this.querySelector('[data-power]');
    this.electricityInput = this.querySelector('[data-electricity]');
    this.priceStatus = this.querySelector('[data-price-status]');
    this.outputs = Object.fromEntries(
      Array.from(this.querySelectorAll('[data-output]')).map((output) => [output.dataset.output, output])
    );
    this.profitOutputs = Array.from(this.querySelectorAll('[data-profit-output]'));
    this.miners = new Map(
      Array.from(this.querySelectorAll('[data-miner-record]')).map((record) => [record.dataset.handle, record])
    );
    this.currentMiner = null;

    this.coinData = {
      BTC: { name: 'Bitcoin (BTC)', priceId: 'bitcoin', fallbackPrice: 64634, coinsPerHashDay: 4.996878992173439e-19 },
      BCH: { name: 'Bitcoin Cash (BCH)', priceId: 'bitcoin-cash', fallbackPrice: 430, coinsPerHashDay: 1.3498597716987838e-16 },
      LTC: { name: 'Litecoin (LTC)', priceId: 'litecoin', fallbackPrice: 47.21, coinsPerHashDay: 1.3899838628744401e-12 },
      DOGE: { name: 'Dogecoin (DOGE)', priceId: 'dogecoin', fallbackPrice: 0.1, coinsPerHashDay: 5.14e-9 },
      BEL: { name: 'Bellscoin (BEL)', priceId: 'bellscoin', fallbackPrice: 0.16, coinsPerHashDay: 8.2e-10 },
      ETC: { name: 'Ethereum Classic (ETC)', priceId: 'ethereum-classic', fallbackPrice: 7.14, coinsPerHashDay: 9.96534008888848e-11 },
      ZIL: { name: 'Zilliqa (ZIL)', priceId: 'zilliqa', fallbackPrice: 0.004, coinsPerHashDay: 8e-8 },
      KAS: { name: 'Kaspa (KAS)', priceId: 'kaspa', fallbackPrice: 0.03148445, coinsPerHashDay: 5.55e-12 },
      ZEC: { name: 'Zcash (ZEC)', priceId: 'zcash', fallbackPrice: 1215.58, coinsPerHashDay: 6.28755019673136e-8 },
      XMR: { name: 'Monero (XMR)', priceId: 'monero', fallbackPrice: 428.4, coinsPerHashDay: 7.0047657471e-8 },
      XTM: { name: 'Minotari (XTM)', priceId: 'minotari-tari', fallbackPrice: 0.001537, coinsPerHashDay: 3.4413793103448277e-9 },
      ALEO: { name: 'Aleo (ALEO)', priceId: 'aleo', fallbackPrice: 0.01289013, coinsPerHashDay: 1.0303616e-7 }
    };

    if (!this.minerInput || !this.minerInput.options.length) return;

    this.minerInput.addEventListener('change', () => this.selectMiner());
    this.variantInput.addEventListener('change', () => this.updateSelection());
    this.coinSelector.addEventListener('change', () => this.updateSelection());
    this.electricityInput.addEventListener('input', () => this.calculate());

    this.selectMiner();
    this.loadPrices();
  }

  disconnectedCallback() {
    if (this.controller) this.controller.abort();
  }

  selectMiner() {
    const record = this.miners.get(this.minerInput.value);
    if (!record) return;

    this.populateSelect(this.variantInput, record.querySelector('[data-variant-options]'));
    this.populateSelect(this.coinSelector, record.querySelector('[data-coin-options]'));
    this.updateSelection();
  }

  updateSelection() {
    const record = this.miners.get(this.minerInput.value);
    if (!record) return;

    const coin = this.coinSelector.value || 'BTC';
    const variantLabel = this.variantInput.value || record.dataset.baseHashrate || '0 H/s';
    const hashrate = this.parseHashrate(variantLabel);
    const baseHashrate = this.parseHashrate(record.dataset.baseHashrate || variantLabel);
    const basePower = Number(String(record.dataset.basePower || '0').replace(/,/g, ''));
    const power = baseHashrate > 0 ? Math.round(basePower * hashrate / baseHashrate) : basePower;
    const market = this.coinData[coin] || this.coinData.BTC;
    const dailyCoins = hashrate * market.coinsPerHashDay;

    this.currentMiner = { coin, hashrate, power, dailyCoins };
    this.coinInput.value = market.name;
    this.hashrateInput.value = variantLabel;
    this.priceInput.value = this.formatNumber(market.livePrice || market.fallbackPrice, 8);
    this.dailyCoinsInput.value = this.formatNumber(dailyCoins, 8);
    this.powerInput.value = Number.isFinite(power) ? power.toLocaleString('en-GB') : '0';
    this.calculate();
  }

  populateSelect(select, template) {
    select.replaceChildren();
    if (template) select.append(template.content.cloneNode(true));
  }

  async loadPrices() {
    this.priceStatus.textContent = this.dataset.statusLoading;
    this.controller = new AbortController();

    try {
      const response = await fetch(this.dataset.endpoint, {
        headers: { Accept: 'application/json' },
        signal: this.controller.signal
      });
      if (!response.ok) throw new Error(String(response.status));

      const prices = await response.json();
      Object.values(this.coinData).forEach((coin) => {
        const livePrice = Number(prices[coin.priceId] && prices[coin.priceId].gbp);
        if (Number.isFinite(livePrice) && livePrice > 0) coin.livePrice = livePrice;
      });

      this.priceStatus.textContent = this.dataset.statusReady;
      this.updateSelection();
    } catch (error) {
      if (error.name === 'AbortError') return;
      this.priceStatus.textContent = this.dataset.statusFallback;
      this.updateSelection();
    }
  }

  calculate() {
    if (!this.currentMiner) return;

    const market = this.coinData[this.currentMiner.coin] || this.coinData.BTC;
    const price = market.livePrice || market.fallbackPrice;
    const electricityRate = Math.max(0, Number(this.electricityInput.value) || 0);
    const dailyEnergy = this.currentMiner.power / 1000 * 24;
    const grossDaily = price * this.currentMiner.dailyCoins;
    const electricityDaily = dailyEnergy * electricityRate;
    const netDaily = grossDaily - electricityDaily;

    this.outputs.gross.textContent = this.formatCurrency(grossDaily);
    this.outputs.energy.textContent = dailyEnergy.toFixed(2) + ' kWh';
    this.outputs.electricity.textContent = this.formatCurrency(electricityDaily);
    this.outputs.daily.textContent = this.formatCurrency(netDaily);
    this.outputs.monthly.textContent = this.formatCurrency(netDaily * 30);
    this.outputs.yearly.textContent = this.formatCurrency(netDaily * 365);

    this.profitOutputs.forEach((output) => {
      output.classList.toggle('is-positive', netDaily > 0);
      output.classList.toggle('is-negative', netDaily < 0);
    });
  }

  parseHashrate(value) {
    const normalized = String(value).replace(/,/g, '');
    const numbers = normalized.match(/\d+(?:\.\d+)?/g) || ['0'];
    const amount = Number(numbers[numbers.length - 1]);
    const unitMatch = normalized.match(/([KMGTPE]?)H\/?s/i);
    const unit = unitMatch ? unitMatch[1].toUpperCase() : '';
    const multipliers = { '': 1, K: 1e3, M: 1e6, G: 1e9, T: 1e12, P: 1e15, E: 1e18 };
    return amount * (multipliers[unit] || 1);
  }

  formatNumber(value, maximumFractionDigits) {
    return new Intl.NumberFormat('en-GB', {
      useGrouping: false,
      maximumFractionDigits
    }).format(value);
  }

  formatCurrency(value) {
    const maximumFractionDigits = Math.abs(value) < 1 ? 4 : 2;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits
    }).format(value);
  }
}

if (!customElements.get('miner-profitability-calculator')) {
  customElements.define('miner-profitability-calculator', MinerProfitabilityCalculator);
}

  } catch(e) { console.error(e); }
})();
})();
